import React from "react";
import {Navigate, Route, Routes as ReactRoutes} from "react-router-dom";
import {routeConfigs} from "../../navigation/routeConfig";
import Dashboard from "../../routes/Dashboard/Dashboard";
import OpenOrders from "../../routes/Orders/OpenOrders";
import Reports from "../../routes/Reports/Reports";
import Profile from "../../routes/Profile/Profile";
import PharmacyProfile from "../../routes/PharmacyProfile/PharmacyProfile";
import BankAccount from "../../routes/BankAccount/BankAccount";
import Pharmacies from "../../routes/Pharmacies/Pharmacies";
import Pharmacy from "../../routes/Pharmacies/Pharmacy/Pharmacy";
import SellList from "../../routes/Sell/SellList";
import NewSellItem from "../../routes/Sell/NewSellItem/NewSellItem";
import EditSellItem from "../../routes/Sell/EditSellItem/EditSellItem";
import Buy from "../../routes/Buy/Buy";
import Checkout from "../../routes/Checkout/Checkout";
import SellerListings from "../../routes/SellerListings/SellerListings";
import BuyHistory from "../../routes/BuyHistory/BuyHistory";
import SellHistory from "../../routes/SellHistory/SellHistory";
import Users from "../../routes/Users/Users";
import AddUser from "../../routes/Users/AddUser/AddUser";
import EditUser from "../../routes/Users/EditUser/EditUser";
import Wishlist from "../../routes/Wishlist/Wishlist";
import NewWishlistItem from "../../routes/Wishlist/NewWishlistItem";
import VacationMode from "../../routes/VacationMode/VacationMode";

interface IRoutes {
  isAdmin: boolean;
}

const Routes:React.FunctionComponent<IRoutes> = ({
  isAdmin
}) => {
  return (
    <ReactRoutes>
      {isAdmin ? (
        <>
          <Route path={routeConfigs.buy.path} element={ <Navigate to={routeConfigs.pharmacies.path} /> } />
          <Route path={routeConfigs.pharmacies.path} element={<Pharmacies />} />
          <Route path={routeConfigs.pharmacy.path} element={<Pharmacy />} />
          <Route path={routeConfigs.postings.path} element={<SellList isAdmin />} />
          <Route path={routeConfigs.editSellItem.path} element={<EditSellItem isAdmin />} />
          <Route path={routeConfigs.sales.path} element={<BuyHistory isAdmin />} />
          <Route path={routeConfigs.orders.path} element={<SellHistory isAdmin />} />
          <Route path={routeConfigs.reports.path} element={<Reports />} />
          <Route path="*" element={<div>Not found</div>} />
        </>
      ) : (
        <>
          <Route path={routeConfigs.buy.path} element={<Buy />} />
          <Route path={routeConfigs.sell.path} element={<SellList />} />
          <Route path={routeConfigs.wishlist.path} element={<Wishlist />} />
          <Route path={routeConfigs.newWishlistItem.path} element={<NewWishlistItem />} />
          <Route path={routeConfigs.newSellItem.path} element={<NewSellItem />} />
          <Route path={routeConfigs.editSellItem.path} element={<EditSellItem />} />
          <Route path={routeConfigs.buyHistory.path} element={<BuyHistory />} />
          <Route path={routeConfigs.sellHistory.path} element={<SellHistory />} />
          <Route path={routeConfigs.openOrders.path} element={<OpenOrders />} />
          <Route path={routeConfigs.profile.path} element={<Profile />} />
          <Route path={routeConfigs.login.path} element={ <Navigate to={routeConfigs.buy.path} /> } />
          <Route path={routeConfigs.signUp.path} element={ <Navigate to={routeConfigs.buy.path} /> } />
          <Route path={routeConfigs.forgotPassword.path} element={ <Navigate to={routeConfigs.buy.path} /> } />
          <Route path={routeConfigs.pharmacyProfile.path} element={<PharmacyProfile />} />
          <Route path={routeConfigs.bankAccount.path} element={<BankAccount />} />
          <Route path={routeConfigs.checkout.path} element={<Checkout />} />
          <Route path={routeConfigs.sellerListings.path} element={<SellerListings />} />
          <Route path={routeConfigs.dashboard.path} element={<Dashboard />} />
          <Route path={routeConfigs.vacationMode.path} element={<VacationMode />} />
          <Route path={routeConfigs.users.path} element={<Users />} />
          <Route path={routeConfigs.addUser.path} element={<AddUser />} />
          <Route path={routeConfigs.editUser.path} element={<EditUser />} />
          <Route path="*" element={<div>Not found</div>} />
        </>
      )}
    </ReactRoutes>
  )
}

export default Routes;